import { render } from "./InstantUnstake.vue?vue&type=template&id=35ec2aea"
import script from "./InstantUnstake.vue?vue&type=script&lang=js"
export * from "./InstantUnstake.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/InstantUnstake.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35ec2aea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35ec2aea', __exports__)) {
    api.reload('35ec2aea', __exports__)
  }
  
  module.hot.accept("./InstantUnstake.vue?vue&type=template&id=35ec2aea", () => {
    api.rerender('35ec2aea', render)
  })

}


export default __exports__